import { trigger, transition, style, query, group, animate } from '@angular/animations';

export const slider = trigger('routeAnimations', [
  transition(':increment', slideTo('right')),
  transition(':decrement', slideTo('left')),
]);

function slideTo(direction) {
  const optional = { optional: true };
  return [
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }),
      ],
      optional
    ),
    query(':enter', [style({ transform: direction === 'right' ? 'translateX(100%)' : 'translateX(-100%)' })], optional),
    group([
      query(':leave', [animate('600ms ease-in-out', style({ transform: direction === 'right' ? 'translateX(-100%)' : 'translateX(100%)' }))], optional),
      query(':enter', [animate('600ms ease-in-out', style({ transform: 'translateX(0)' }))], optional),
    ]),
  ];
}
